import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Range } from "@pdfking/tfunc"
import { Icon } from "@pdfking/workflow/components/Icon"

export const Rating = CreateRenderFunction({
  props: {
    name: "",
    value: 0,
  },
  data: {
    local: 0,
  },
  computed: { range: () => [...Range(2, 10, 2)] },
  init() {
    this.local = this.value
  },
  render() {
    return (
      <div class="rating-widget">
        <input name={this.name} type="hidden" value={this.local} />
        {this.range.map((i: number) => (
          <span
            key={i}
            style="cursor: pointer"
            onClick={() => {
              this.local = i
            }}
          >
            <Icon name={i <= this.local ? "STAR" : "STAR_EMPTY"} />
          </span>
        ))}
      </div>
    )
  },
})
